import angular from "angular";
import { configureStates } from "../../../core/router/router-helper.provider";
import { ImageCropperModal } from "../../shared/image-cropper/image-cropper-modal.component";

const routes = [{
    // User's own user profile.
    state: "account.userProfile",
    config: {
        url: "/profile",
        component: "apexUserProfileDetail",
        resolve: {
            userProfile: employeeService => {
                'ngInject';
                return employeeService.retrieveIdentity()
                    .then(identity => employeeService.retrieveEmployeeProfile(identity.EmployeeID));
            },
            profileImage: (userProfile, employeeService) => {
                'ngInject';
                return employeeService.retrieveProfileImageUrl(userProfile.Id);
            },
            // User can edit their own profile
            canEdit: () => true,
            onChangeProfileImage: $state => {
                'ngInject';
                return ["$event", params => {
                    $state.go(".cropProfileImage", params)
                }]
            },
            onChangeEmailAddress: ($state, userProfile, employeeService, utilityService) => {
                'ngInject';
                return ["$event", ({ employeeID, emailAddress }) => {
                    const saving = employeeService.patchEmployeeProfile(employeeID, {
                        ...userProfile,
                        EmailAddress: emailAddress
                    });
                    utilityService.showLoadingUntilResolved(
                        utilityService.alertOnError(saving, "Changing email failed")
                    );
                    return saving.then(() => $state.reload());
                }];
            }
        },
        data: {
            pageHeader: "Account Profile"
        }
    }
}, {
    state: "account.userProfile.cropProfileImage",
    config: {
        params: {
            dataUrl: { type: "string" }, // Base64 encoded image data URL
            fileName: { type: "string" },
            fileType: { type: "string" }
        },
        onEnter: ($uibModal, $state, $transition$, userProfile, employeeService, fileService, utilityService) => {
            'ngInject';
            const { dataUrl, fileName, fileType } = $transition$.params();
            $uibModal.open({
                ...ImageCropperModal,
                resolve: {
                    dataUrl: () => dataUrl,
                    cropHeight: () => 256,
                    cropWidth: () => 256,
                    resultHeight: () => 256,
                    resultWidth: () => 256,
                    areaType: () => "square"
                }
            }).result
                .then(imageData => {
                    if (imageData) {
                        return fileService.dataUrlToFile(imageData, fileName, fileType);
                    }
                }, () => {})
                .then(file => {
                    if (file) {
                        return employeeService.updateEmployeeProfileImage(userProfile.Id, file);
                    }
                })
                .then(() => $state.go("^", undefined, { reload: true }))
                .catch(ex => {
                    if (ex) {
                        alert("Saving profile image failed" + ": " + utilityService.getExceptionMessage(ex));
                    }
                    // Exit state without refreshing page.
                    $state.go("^");
                });
        }
    }
}];

export const UserProfileRoutingModule = angular
    .module("apex.mainApp.account.userProfile.routing", [])
    .run(configureStates(routes))
    .name;
